import type { EdgeData, NodeId } from '@ipfabric/utils';

export const getEdgeOtherNodeId =
  (nodeId: NodeId) =>
  ({ source, target }: EdgeData): NodeId =>
    nodeId === source ? target : source;
